import { render } from "./BoardView.vue?vue&type=template&id=47327e1b"
import script from "./BoardView.vue?vue&type=script&lang=js"
export * from "./BoardView.vue?vue&type=script&lang=js"

import exportComponent from "/home/treim/code/trit/reclo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__